import axios from "axios";
import { getCookieValue } from "./cookies";
import { logger } from "./logger";
import { getRecaptchaToken } from "./getRecaptchaToken";
import { EMAIL_CHECK_RECAPTCHA_ACTION_KEY } from "./constants";

const accountService = axios.create({
  baseURL: window.ww.wwAPI,
  timeout: 5000
});

export async function updateAssessmentId({ seqAssessmentId, market }) {
  const token = getCookieValue("wwSession");

  try {
    logger("Updating assessment id", {
      level: "info",
      customAttributes: { seqAssessmentId }
    });

    const assessmentIdUpdated = await accountService.post(
      `/account/v1/profile/update/assessment-id?market=${market}`,
      {
        seqAssessmentId
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );

    logger("Successfully updated assessment id", {
      level: "info",
      customAttributes: { seqAssessmentId }
    });

    return assessmentIdUpdated;
  } catch (error) {
    logger("Error updating assessment id", {
      level: "error",
      customAttributes: { seqAssessmentId, error }
    });
  }
}

export async function checkEmail({ email }) {
  try {
    logger("Checking email", {
      level: "info"
    });

    const recaptchaToken = await getRecaptchaToken(
      EMAIL_CHECK_RECAPTCHA_ACTION_KEY
    );

    const checkEmailResponse = await accountService.post(
      `/account/v1/check/email?market=en-US`,
      {
        key: email
      },
      {
        headers: {
          "Content-Type": "application/json",
          ...(recaptchaToken ? { "X-Recaptcha-Token": recaptchaToken } : {})
        }
      }
    );

    logger("Successfully checked email", {
      level: "info"
    });

    return checkEmailResponse.data;
  } catch (error) {
    logger("Error checking email", {
      level: "error",
      customAttributes: { error }
    });

    return null;
  }
}
